export const KEYBOARD_HANDLERS = ['keyup', 'keydown'];
